'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { SvgAdd } from '@common/icon';
import { DONATION_ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
export interface AddGiftButtonProps {
  institutionId: number;
  className?: string;
}
export const AddGiftButton = t0 => {
  const $ = _c(8);
  const {
    institutionId,
    className
  } = t0;
  const {
    push
  } = useCustomRouter();
  let t1;
  if ($[0] !== institutionId || $[1] !== push) {
    t1 = () => {
      push(DONATION_ROUTES.GIFTS.withSearchParams({
        searchParams: {
          institutionId
        }
      }));
    };
    $[0] = institutionId;
    $[1] = push;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleClick = t1;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SvgAdd className="size-16" />;
    t3 = <span>답례품 추가</span>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== className || $[6] !== handleClick) {
    t4 = <Button className={className} dimensions="H40" theme="sub-line" onClick={handleClick}>{t2}{t3}</Button>;
    $[5] = className;
    $[6] = handleClick;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};